import(/* webpackMode: "eager" */ "/root/workspace/findin-web_I5sE/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/root/workspace/findin-web_I5sE/app/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkErrorHandler"] */ "/root/workspace/findin-web_I5sE/components/ChunkErrorHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/workspace/findin-web_I5sE/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalTaskNotificationBridge"] */ "/root/workspace/findin-web_I5sE/components/notifications/GlobalTaskNotificationBridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileDetect"] */ "/root/workspace/findin-web_I5sE/components/site/MobileDetect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/workspace/findin-web_I5sE/components/UmengAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageGenerationSocketProvider"] */ "/root/workspace/findin-web_I5sE/features/research-drawing/ImageGenerationSocketContext.tsx");
;
import(/* webpackMode: "eager" */ "/root/workspace/findin-web_I5sE/node_modules/katex/dist/katex.min.css");
